import React from "react";
import HtmlReactParser from "html-react-parser";
import DropBoxEmpty from "../../components/DropBoxEmpty";

/**
 * 文章裡的填空格後面該不該補一個換行。
 *
 * List of Headings 這類題型，填空格應該自己一行、在段落上方。但題庫裡有三種
 * 打法：有的標記後面已經有 <br>，有的標記就在段落結尾，還有 42 題（共 130 題）
 * 是「A [27] 段落內文……」全部擠在同一行——那格就卡在文字中間，很難讀。
 *
 * 改題庫治標而且以後出題還會再犯，所以在這裡補。已經換行或已經到段落結尾的
 * 不補，免得多出一個空行。
 */
export const needsBreakAfter = (nextHtml) => {
  const probe = (nextHtml || "").replace(
    /^(?:\s|&nbsp;|<\/(?:span|strong|b|i|em|u)>)+/i,
    ""
  );
  if (probe === "") {
    return false;                       // 後面沒東西了
  }
  return !/^<br/i.test(probe) && !/^<\/p>/i.test(probe);
};

const DropQuestion = ({
  questions,
  preContent,
  postContent,
  className,
  toggleQuestion,
  chosenQuestion,
  checkAnsweredQuestion,
  generateReplacedText,
  storeAnswers,
  storedAnswers,
}) => {
  return (
    <div className={className}>
      {HtmlReactParser(
        `${preContent ?? ""}${questions
          .map((question, index) => {
            // 這一格後面接的內容 = 下一段的開頭（最後一格則是 postContent）
            const following =
              index + 1 < questions.length
                ? questions[index + 1].question
                : postContent ?? "";
            const lineBreak = needsBreakAfter(following) ? "<br>" : "";
            return `${question.question}<question data-input="${question.id}">${question.id}</question>${lineBreak}`;
          })
          .join("")}${postContent ?? ""}`,
        {
          replace: (domhandlerNode) => {
            if (domhandlerNode.name === "question") {
              return (
                <DropBoxEmpty
                  id={parseInt(domhandlerNode.attribs["data-input"])}
                  toggleQuestion={toggleQuestion}
                  chosenQuestionId={chosenQuestion}
                  checkAnsweredQuestion={checkAnsweredQuestion}
                  generateReplacedText={generateReplacedText}
                  storeAnswers={storeAnswers}
                  storedAnswers={storedAnswers}
                />
              );
            }
          },
        }
      )}
    </div>
  );
};

export default DropQuestion;
